import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Integrations from '../../../integration/Integrations.jsx';
import UrlRegex from "../../../common/regex/urlregex.component.jsx";
class ExportErrorEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            invoice: this.props.invoice || null,
            quote: this.props.quote || null,
            modal: '',
        }
        this.openIntercom = this.openIntercom.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            invoice: nextProps.invoice || null,
            quote: nextProps.quote || null,
        })
    }

    openIntercom(event) {
        event.preventDefault()
        if (window.Intercom) {
            window.Intercom('show')
        }
    }

    render() {
        const obj = this.state.invoice || this.state.quote
        return <div className={"row " + this.state.className}>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    <FormattedMessage
                        id="common.analytics.events.exported.error.text"
                        defaultMessage="Export to {integration} of {identifier} failed with this message:"
                        values={{
                            identifier: <strong>{obj.attributes.identifier}</strong>,
                            integration: Integrations.getIntegrationNameFromKey(this.state.object.attributes.integrationKey),
                        }}
                    />
                </p>
            </div>
            <div className={'col-12 mb-2'}>
                <samp>
                    <small>
                        <UrlRegex
                            value={this.state.object.attributes.note}
                        />
                    </small>
                </samp>
            </div>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    <a href={'#'} onClick={this.openIntercom}>
                        <FormattedMessage
                            id="common.analytics.events.exported.error.contact_support_message"
                            defaultMessage="You can contact support to help you sort this out"
                        />
                    </a>
                </p>
            </div>
        </div>
    }

}

export default ExportErrorEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/export-error.component.jsx